/*
  Function to get all the available projects found in
  localstorage with the key "db"
*/
export const getAllProjects = () => {
  // Get the array of projects by the id of "db"
  // from localstorage
  const db = localStorage.getItem("db") || "[]";
  // Only strings can be saved in localstorage
  // so the output should be parsed into JSON
  return JSON.parse(db);
};

/*
  Function to find a specific project with given project ID
*/
export const getProjectById = (projectId) => {
  // Get the array of projects , if the projects is empty
  // return an empty array
  const dbString = localStorage.getItem("db") || "[]";
  // parse the database
  const db = JSON.parse(dbString);
  // filter the database with the id
  // "you can also use Array.find() method"
  const selected = db.filter((e) => e.projectId === projectId);
  // return the first selected array
  return selected[0];
};

export const getProjectCounts = () => {
  const projects = getAllProjects();
  return projects.length;
};
